import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Main from "../../components/Main";
import Banner from "../../components/Banner";
import Popups from "../../components/Popups";
import { useRouter } from "next/router";
import Polling from "../../components/Polling";
import useResponsive from "../../hooks/useResponsive";

const Layout = ({ children, banner = undefined }) => {
  const router = useRouter();
  const { isSm } = useResponsive();

  const isNotTerms = !(router.pathname === "/swap");

  return (
    <div className="z-0 flex flex-col items-center w-full min-h-screen lg:pb-0">
      {banner && <Banner />}
      {isNotTerms && <Header />}
      <Main>{children}</Main>
      <div className=""></div>
      {/* {isNotTerms && <Footer />} */}
      <div className="fixed right-4 bottom-4">{isSm && <Polling />}</div>
      <Footer />

      <Popups />
    </div>
  );
};

export default Layout;
